import { render, staticRenderFns } from "./select_brand.vue?vue&type=template&id=d484252a&scoped=true&"
import script from "./select_brand.vue?vue&type=script&lang=js&"
export * from "./select_brand.vue?vue&type=script&lang=js&"
import style0 from "./select_brand.vue?vue&type=style&index=0&id=d484252a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484252a",
  null
  
)

export default component.exports